import { partnerQueryKeys as e } from "./usePartnerQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { partnerApplicationsApi as n } from "@maat/api-main";
//#region src/partners/useMyPartnerApplicationQuery.ts
var r = (r) => t({
	queryKey: e.application(),
	queryFn: () => n.me(),
	enabled: r?.enabled ?? !0
});
//#endregion
export { r as useMyPartnerApplicationQuery };
